import type { SiteContentOverride } from '@/config/models'
import type { AppEnvironment } from '@/lib/deployment'

export const environmentOverrides: Record<AppEnvironment, SiteContentOverride> = {
  development: {
    seo: {
      noIndex: true,
    },
  },
  preview: {
    seo: {
      noIndex: true,
    },
  },
  staging: {
    seo: {
      noIndex: true,
    },
  },
  test: {
    seo: {
      noIndex: true,
    },
  },
  production: {
    seo: {
      noIndex: false,
    },
  },
}
